import { Navigate, Route, Routes } from "react-router-dom";
import ProtectedRoute from "@components/ProtectedRoute";
import HomeContentPage from "@components/home_content";
import OnBoardingPage from "@components/on_boarding";
import { useAuth } from "@context/AuthContext";
import ForgotPasswordPage from "@pages/ForgotPasswordPage";
import RegisterPage from "@pages/RegisterPage";
import DashboardPage from "@pages/dashboard";
import CmsPurchasesPage from "@pages/cms_purchases";
import CmsUsersPage from "@pages/cms_users";
import PromoCodeBatchesPage from "@pages/promo_code_batches";
import LanguagesPage from "@languages";
import LoginPage from "@pages/LoginPage";
import MediaPage from "@pages/media";
import ResetPasswordPage from "@pages/ResetPasswordPage";
function AppRoutes() {
  const { authorization, user, isAuthenticated, isLoading } = useAuth();
  const primaryRole = String(authorization?.primaryRole || user?.role || "")
    .toLowerCase()
    .trim();
  const isAdminRole = primaryRole === "admin";
  const superAdminOnly = (element) =>
    isAdminRole ? <Navigate to="/tours" replace /> : element;

  if (isLoading) {
    return <p style={{ padding: 24 }}>Cargando sesion...</p>;
  }

  return (
    <Routes>
      <Route
        path="/"
        element={
          <Navigate to={isAuthenticated ? "/tours" : "/login"} replace />
        }
      />
      <Route
        path="/login"
        element={
          isAuthenticated ? <Navigate to="/tours" replace /> : <LoginPage />
        }
      />
      <Route path="/register" element={<RegisterPage />} />

      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route path="/cms/reset-password" element={<ResetPasswordPage />} />

      <Route element={<ProtectedRoute />}>
        <Route path="/cms" element={<Navigate to="/tours" replace />} />
        <Route path="/tours" element={<DashboardPage />} />
        <Route path="/home-content" element={superAdminOnly(<HomeContentPage />)} />
        <Route path="/on-boarding" element={superAdminOnly(<OnBoardingPage />)} />
        <Route path="/languages" element={superAdminOnly(<LanguagesPage />)} />
        <Route path="/users" element={superAdminOnly(<CmsUsersPage />)} />
        <Route path="/purchases" element={superAdminOnly(<CmsPurchasesPage />)} />
        <Route
          path="/promo-code-batches"
          element={superAdminOnly(<PromoCodeBatchesPage />)}
        />
        <Route path="/media" element={superAdminOnly(<MediaPage />)} />
        <Route path="/settings" element={<DashboardPage />} />
      </Route>

      <Route
        path="*"
        element={
          <Navigate to={isAuthenticated ? "/tours" : "/login"} replace />
        }
      />
    </Routes>
  );
}

export default AppRoutes;
